import { generatePath } from 'react-router-dom';
import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_SOLUTION_COSMOS_SUBSCRIPTION,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_COSMOS_SUBSCRIPTION,
} from '../constants';

const api = (solutionId: string) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_SOLUTION_COSMOS_SUBSCRIPTION, { solutionId }),
  });

const solutionCosmosSubscriptionSlice = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_COSMOS_SUBSCRIPTION,
  responseMapping: ResponseMapping.Default,
});

export default solutionCosmosSubscriptionSlice;
